'use client'

import { styled } from 'styled-components'

export const Ol = styled.ol`
    display : flex;
    flex-wrap : wrap;
    gap : 20px;
    width : 100%;
`